module.exports = __webpack_public_path__ + "img/kX.89157b4a.png";